export default __webpack_public_path__ + "static/media/DSC06068.76afa8b5.jpg";